import type { ReactNode } from "react";

import BottomNav from "@/components/layout/BottomNav";
import MobileHeader from "@/components/layout/MobileHeader";
import Sidebar from "@/components/layout/Sidebar";
import { PageContainer } from "@/components/ui/page-container";

export default function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh w-full bg-background md:h-dvh md:overflow-hidden">
      <Sidebar />

      <div className="flex min-w-0 flex-1 flex-col">
        <MobileHeader />

        {/* Keep the final row above the fixed mobile tab bar and its safe-area inset. */}
        <main className="flex-1 overflow-y-auto px-4 pb-[calc(5rem+env(safe-area-inset-bottom))] pt-4 md:px-8 md:pb-8 md:pt-6">
          {/* Capped so a table's first and last column stay readable together. */}
          <PageContainer>{children}</PageContainer>
        </main>
      </div>

      <BottomNav />
    </div>
  );
}
